import type { HistoryData, Team } from '~/vendor/cxy/types';

export const filterHistoryData = (data: readonly HistoryData[], filter: string, team?: Team, limit?: number) => {
  // Copy before sorting. `data.sort()` reorders the array the CALLER owns — a chart could reorder a
  // sibling's data or a cached response, and it throws outright on a frozen array. `readonly` in the
  // signature is what stops the copy being dropped again.
  const sortedData = [...data]
    .sort((a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime())
    .slice(0, limit);

  let filtered = sortedData;
  if (filter === 'Home') filtered = sortedData.filter(item => item.participant.side === 'HOME');
  else if (filter === 'Away') filtered = sortedData.filter(item => item.participant.side === 'AWAY');
  else if (filter === 'versus' && team) {
    filtered = sortedData.filter(
      item => item.homeTeam.participantId === team.participantId || item.awayTeam.participantId === team.participantId,
    );
  }
  return filtered.reverse();
};
